(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~space"],{

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


 // 样式文件
// import './style/index.scss';

var spaceSizeType = utils__WEBPACK_IMPORTED_MODULE_0__[/* vueTypes */ "d"].oneOfType([utils__WEBPACK_IMPORTED_MODULE_0__[/* vueTypes */ "d"].number, utils__WEBPACK_IMPORTED_MODULE_0__[/* vueTypes */ "d"].oneOf(['small', 'middle', 'large']).def('middle')]);
var spaceSize = {
  small: 8,
  middle: 16,
  large: 24
};
var MegSpace = {
  name: 'MegSpace',
  props: {
    direction: utils__WEBPACK_IMPORTED_MODULE_0__[/* vueTypes */ "d"].oneOf(['vertical', 'horizontal']).def('horizontal'),
    align: utils__WEBPACK_IMPORTED_MODULE_0__[/* vueTypes */ "d"].oneOf(['start', 'end', 'center', 'baseline', 'initial']).def('center'),
    size: spaceSizeType,
    classProps: utils__WEBPACK_IMPORTED_MODULE_0__[/* vueTypes */ "d"].string
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = 'meg-space';
      var direction = this.direction,
          align = this.align,
          classProps = this.classProps;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, classProps, classProps), _defineProperty(_ref, "".concat(prefixCls, "-").concat(direction), direction === 'vertical' || direction === 'horizontal'), _defineProperty(_ref, "".concat(prefixCls, "-align-").concat(align), align === 'start' || align === 'end' || align === 'center' || align === 'baseline' || align === 'initial'), _ref;
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        direction = this.direction,
        align = this.align,
        size = this.size,
        classes = this.classes;
    var child = utils__WEBPACK_IMPORTED_MODULE_0__[/* propsUtil */ "c"].filterEmpty($slots.default);
    if (child.length === 0) return null;

    var _size = typeof size === 'string' ? spaceSize[size] : size || spaceSize.middle;

    return h("div", {
      "class": classnames__WEBPACK_IMPORTED_MODULE_1___default()(classes)
    }, [child.map(function (item, index) {
      return h("div", {
        "class": "meg-space-item meg-space-item-".concat(index === 0 ? 'icon' : 'content'),
        key: "meg-space-item-".concat(index),
        style: index !== child.length - 1 && _defineProperty({}, direction === 'vertical' ? 'marginBottom' : 'marginRight', "".concat(_size, "px"))
      }, [item]);
    })]);
  }
};

MegSpace.install = function (Vue) {
  Vue.component(MegSpace.name, MegSpace);
};

/* harmony default export */ __webpack_exports__["default"] = (MegSpace);

/***/ })

}]);